import React, { useCallback, useEffect } from 'react';
import s from './s.module.less';
import { Form, Input } from 'antd';
import { ISaveBasicInfo } from 'types/ppaOnboarding';
import { IBasicInfoStep } from 'types/newUniprofile';

interface IProps {
    setNextButtonDisabled: (disabled: boolean) => void;
    formId: string;
    onNext: (data: ISaveBasicInfo) => void;
    initValue?: IBasicInfoStep | null;
}

const Step2 = ({ setNextButtonDisabled, formId, onNext, initValue }: IProps) => {
    const [form] = Form.useForm();
    const firstNameVal = Form.useWatch('firstName', form);
    const lastNameVal = Form.useWatch('lastName', form);

    useEffect(() => {
        if (initValue) {
            form.setFieldsValue(initValue);
        }
    }, [initValue, form]);

    useEffect(() => {
        setNextButtonDisabled(!firstNameVal || !lastNameVal);
    }, [firstNameVal, lastNameVal, setNextButtonDisabled]);

    const handleNext = useCallback(
        async (values: Partial<ISaveBasicInfo>) => {
            onNext?.(values);
        },
        [onNext],
    );

    const handleFinishFailed = useCallback(() => {
        // setNextButtonDisabled(true);
    }, []);

    return (
        <div className={s.wrap}>
            <h2>What is your name?</h2>
            <p>Enter your full name as you’d like it to show on your Klarity profile.</p>
            <div className={s.formContainer}>
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleNext}
                    onFinishFailed={handleFinishFailed}
                    id={formId}
                >
                    <Form.Item
                        label="First name"
                        name="firstName"
                        rules={[{ required: true, message: 'Please enter your first name.' }]}
                    >
                        <Input placeholder="Enter your first name" />
                    </Form.Item>
                    <Form.Item
                        label="Last name"
                        name="lastName"
                        rules={[{ required: true, message: 'Please enter your last name.' }]}
                    >
                        <Input placeholder="Enter your last name" />
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Step2;
